<script>
import TextType from "./TextType.vue";
import LanguageModel from "../../models/LanguageModel";
import { QuestionType } from "../../models/QuestionModel";

export default {
  extends: TextType,
  name: QuestionType.Number,
  data() {
    return {
      inputType: "number",
      allowedChars: "0123456789."
    };
  }
};
</script>
